import React from 'react';
import { observer } from 'mobx-react';
import { CellProps } from '../../stores/card/ModeExcel';
import CardStore from '../../stores/card';
import { WeaLocaleProvider } from 'ecCom';
import { Pagination } from 'antd';
const { getLabel } = WeaLocaleProvider;
export interface ExcelTableCellDetailTableProps {
    cell: CellProps;
    card: CardStore;
    form:any;
}

@observer
export default class DetailPagination extends React.Component<ExcelTableCellDetailTableProps, any> {
    pageSizeOptions =['10', '20', '30', '50', '100']

    total = total => ` ${getLabel(18609,"共")+total+' '+getLabel(18256,"条")} `

    onChange = (current) => {
        const { form } = this.props;
        form.pageNum = current;
    }

    showSizeChange = (current, pagesize) => {
        const { form ,card,cell} = this.props;
        form.pageNum = current;
        form.pageSize = pagesize;
        card.saveDetailPageSize(pagesize,cell.detail);
    }

    render() {
        const { form } = this.props;
        const total = form.values().length;
        return (
            <div className="cube-detail-paging">
                <Pagination
                    showSizeChanger
                    showQuickJumper
                    total={total}
                    current={form.pageNum}
                    defaultCurrent={1}
                    showTotal={this.total}
                    pageSize={form.pageSize}
                    pageSizeOptions={this.pageSizeOptions}
                    onChange={this.onChange}
                    onShowSizeChange={this.showSizeChange}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/DetailPagination.tsx